import React from "react";
import style from "./Avatar.module.scss";
import useDomainStore from "../../stores/domain";

function Avatar({ size = "small", name = "N", className }) {
  const { isKurvDomain } = useDomainStore();
  
  const getSizeClass = (size) => {
    if (size == "small") return style.small;
    if (size == "medium") return style.medium;
    if (size == "xs") return style.xs;
  };

  return (
    <span 
      className={`${style.avatar} ${getSizeClass(size)} ${className}`}
      style={isKurvDomain ? { backgroundColor: "#22A276" } : {}}
    >
      {name}
    </span>
  );
}

export default Avatar;
